import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface UnreadIndicatorProps {
  className?: string
  iconClassName?: string
}

const UnreadIndicator = ({ className, iconClassName }: UnreadIndicatorProps): ReactNode => (
  <div className={twMerge('flex items-center rounded-full p-1 text-xs', className)}>
    <div className={twMerge('size-[5px] rounded-full bg-brand-primary', iconClassName)} />
  </div>
)

export default UnreadIndicator
